import type { IntlShape } from "@formatjs/intl";
import { Button, Flex, Popover, Typography } from "antd";
import { useState } from "react";
import type { EmojiEnum } from "../../app/generated-axios-client/myModel/emoji-enum";
import {
  COMMENT_REACTION_EMOJIS,
  COMMENT_REACTION_GLYPHS,
} from "../constants/commentReactions";
import styles from "./CommentReactionPicker.module.css";

type CommentReactionPickerProps = {
  reactedEmojis: EmojiEnum[];
  pendingEmojis: EmojiEnum[];
  onToggle: (emoji: EmojiEnum) => void;
  intl: IntlShape;
  triggerClassName?: string;
};

export const CommentReactionPicker = ({
  reactedEmojis,
  pendingEmojis,
  onToggle,
  intl,
  triggerClassName,
}: CommentReactionPickerProps) => {
  const [open, setOpen] = useState(false);

  const pickReaction = (emoji: EmojiEnum) => {
    setOpen(false);
    onToggle(emoji);
  };

  const reactionOptions = (
    <Flex gap={4}>
      {COMMENT_REACTION_EMOJIS.map((emoji) => {
        const reacted = reactedEmojis.includes(emoji);
        return (
          <Button
            key={emoji}
            type="text"
            className={
              reacted
                ? `${styles.reactionOption} ${styles.reactionOptionReacted}`
                : styles.reactionOption
            }
            aria-pressed={reacted}
            aria-label={intl.formatMessage({ id: `comment_reaction_${emoji}` })}
            disabled={pendingEmojis.includes(emoji)}
            onClick={() => pickReaction(emoji)}
          >
            {COMMENT_REACTION_GLYPHS[emoji]}
          </Button>
        );
      })}
    </Flex>
  );

  return (
    <Popover
      content={reactionOptions}
      trigger="click"
      open={open}
      onOpenChange={setOpen}
      arrow={false}
    >
      <Typography.Link className={triggerClassName}>
        {intl.formatMessage({ id: "comment_react" })}
      </Typography.Link>
    </Popover>
  );
};
